module.exports = __webpack_public_path__ + "static/media/pic18-min.da79a74d.jpg";